/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentDto } from '../../models/amoxcalli-student-dto';

export interface ApiStudentsGet$Json$Params {
  groupId?: string;
}

export function apiStudentsGet$Json(http: HttpClient, rootUrl: string, params?: ApiStudentsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliStudentDto>>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsGet$Json.PATH, 'get');
  if (params) {
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliStudentDto>>;
    })
  );
}

apiStudentsGet$Json.PATH = '/api/students';
